import { render, staticRenderFns } from "./DialogContentTopics.vue?vue&type=template&id=53f84a4c&scoped=true"
import script from "./DialogContentTopics.vue?vue&type=script&lang=js"
export * from "./DialogContentTopics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f84a4c",
  null
  
)

export default component.exports